const observer = require("node-observer");

/**
 * Class used to create a registry dict
 */
export default class Registry{
    static _objects = {};

    /**
     * Use to register an object to registry
     *
     * @param {string} key
     * @param {*} object
     */
    static register(key, object){
        Registry._objects[key] = object;
        observer.send(this, "registered", {
            key: key,
            data: object
        });
    }

    /**
     * Use to retrieve a registered object
     * If object not found, null is returned
     *
     * @param {string} key
     */
    static registered(key){
        if(Registry._objects.hasOwnProperty(key))
            return Registry._objects[key];
        return null;
    }

    static observe(cls, key, callback = function(data){}){
        observer.subscribe(cls, "registered", (cls, data) => {
            if(data.key === key)
                callback(data.data);
        });

        return Registry.registered(key);
    }

    static remove(key){
        Registry.register(key, null);
    }
}



// WEBPACK FOOTER //
// ./src/Utils/Registry.js